import * as action from '../actions/actions';

const initialState = {
	mapData: {
		loading: true,
		timestamp: 0,
		countries: [],
		error: ""
	}
}

const mapReducer = (state = initialState, action) => {
	if (action.type === "APIRES") {
		
		let countries = action.mapData.data.filter(c => {
            if (c.active > 0) {
            	return true;
            }
		});
        countries = countries.map (c => {
        	return { countryInfo: c.countryInfo, recovered: c.recovered, cases: c.cases, deaths: c.deaths, updated: c.updated, country: c.country }
        });
        countries.sort((a, b) => b.cases - a.cases);
        return { ...state, mapData: { ...state.mapData, countries: countries, loading: false, error: false }  }
	}
	else if (action.type === "APIError") {
		return {...state, error: action.error, loading: false}
	}
	else {
		return state;
	}
}

export default mapReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/mapReducer.js